import {Button} from "components/button";
import Card from "components/card";
import {useEffect, useState} from "react";
import {financialService} from "views/services/finantcialService";
import {FinancialMetricTypesEnum} from "../../../types/financial";

const FeeView = () => {
  const [fee, setFee] = useState("");
  const [followingsFee, setFollowingsFee] = useState("");
  const [tokenCreationFee, setTokenCreationFee] = useState("");
  const [lowFeeUsd, setLowFeeUsd] = useState("");
  const [transactionUsdBound, setTransactionUsdBound] = useState("");
  const [crowdfundingBoundUsd, setCrowdfundingBoundUsd] = useState("");
  const [loading, setLoading] = useState(false);
  const [setting, setSetting] = useState(false);
  const [error, setError] = useState('');

  const getFee = async (type?: FinancialMetricTypesEnum) => {
    try{
      setLoading(true)
      const res = await financialService.getFinancialMetrics(type);
      if (type === FinancialMetricTypesEnum.LOW_BASE_FEE_USD) {
        setLowFeeUsd(res.toString())
      } else if (type === FinancialMetricTypesEnum.TRANSACTION_USD_BOUND) {
        setTransactionUsdBound(res.toString())
      } else if (type === FinancialMetricTypesEnum.CROWDFUNDING_USD_BOUND) {
        setCrowdfundingBoundUsd(res.toString())
      }  else {
        setFee(res.toString());
      }

    } catch {} finally {
      setLoading(false);
    }
  }

  const getFollowingsFee = async () => {
    try{
      setLoading(true)
      const resFollowings = await financialService.getFinancialFollowingsMetrics();
      console.log({resFollowings});
      setFollowingsFee(resFollowings.toString());
    } catch {} finally {
      setLoading(false);
    }
  }

  const getTokenCreationFee = async () => {
    try{
      setLoading(true)
      const res = await financialService.getTokenCreatorMetrics();
      setTokenCreationFee(res.toString());
    } catch {} finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getFee();
    getFee(FinancialMetricTypesEnum.LOW_BASE_FEE_USD);
    getFee(FinancialMetricTypesEnum.TRANSACTION_USD_BOUND);
    getFee(FinancialMetricTypesEnum.CROWDFUNDING_USD_BOUND);
    getFollowingsFee();
    getTokenCreationFee();
  }, [])

  const handleSetFee = async () => {
    if (+fee > 100 || +fee < 0) {
      setFee('1');
      return;
    }
    try{
      setSetting(true)
      await financialService.setFee(+fee, FinancialMetricTypesEnum.BASE_FEE);
    } catch {

    } finally {
      setSetting(false);
    }
  };

  const handleSetLowFeeUsd = async () => {
    if (+lowFeeUsd > 100 || +lowFeeUsd < 0) {
      setLowFeeUsd('1');
      return;
    }
    try{
      setSetting(true)
      await financialService.setFee(+lowFeeUsd, FinancialMetricTypesEnum.LOW_BASE_FEE_USD);
    } catch {

    } finally {
      setSetting(false);
    }
  };

  const handleSetTxUsdBound = async () => {
    if (+transactionUsdBound > 100 || +transactionUsdBound < 0) {
      setTransactionUsdBound('1');
      return;
    }
    try{
      setSetting(true)
      await financialService.setFee(+transactionUsdBound, FinancialMetricTypesEnum.TRANSACTION_USD_BOUND);
    } catch {

    } finally {
      setSetting(false);
    }
  };
  const handleSetFollowingsFee = async () => {
    if (+followingsFee > 100 || +followingsFee < 0) {
      setFollowingsFee('1');
      return;
    }
    try{
      setSetting(true)
      await financialService.setFee(+followingsFee, FinancialMetricTypesEnum.FOLLOWINGS_BUYS_FEE);
    } catch {

    } finally {
      setSetting(false);
    }
  };

  const handleSetTokenCreatorFee = async () => {
    if (+tokenCreationFee > 100 || +tokenCreationFee < 0) {
      setTokenCreationFee('1');
      return;
    }
    try{
      setSetting(true)
      await financialService.setFee(+tokenCreationFee, FinancialMetricTypesEnum.TOKEN_CREATOR_FEE);
    } catch {

    } finally {
      setSetting(false);
    }
  };

  const handleSetCrowdfundingUsdBound = async () => {
    if (+crowdfundingBoundUsd < 0) {
      return;
    }
    try{
      setSetting(true)
      await financialService.setFee(+crowdfundingBoundUsd, FinancialMetricTypesEnum.CROWDFUNDING_USD_BOUND);
    } catch {

    } finally {
      setSetting(false);
    }
  };

  const handleInputCrowdfundingUsdBound = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFee = e.target.value;
    if (+newFee < 0) {
      setError('Input valid number in a range from 0')
      setCrowdfundingBoundUsd(e.target.value);
    } else {
      setError('');
      setCrowdfundingBoundUsd(e.target.value);
    }
  }

  const handleInputFee = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFee = e.target.value;
    if (+newFee > 100 || +newFee < 0) {
      setError('Input valid number in a range from 0 to 100')
      setFee(e.target.value);
    } else {
      setError('');
      setFee(e.target.value);
    }
  }

  const handleInputLowFeeUsd = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFee = e.target.value;
    if (+newFee > 100 || +newFee < 0) {
      setError('Input valid number in a range from 0 to 100')
      setLowFeeUsd(e.target.value);
    } else {
      setError('');
      setLowFeeUsd(e.target.value);
    }
  }

  const handleInpuTxUsdBound = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFee = e.target.value;
    if (+newFee > 100 || +newFee < 0) {
      setError('Input valid number in a range from 0 to 100')
      setTransactionUsdBound(e.target.value);
    } else {
      setError('');
      setTransactionUsdBound(e.target.value);
    }
  }
  const handleInputFollowingsFee = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFee = e.target.value;
    if (+newFee > 100 || +newFee < 0) {
      setError('Input valid number in a range from 0 to 100')
      setFollowingsFee(e.target.value);
    } else {
      setError('');
      setFollowingsFee(e.target.value);
    }
  }

  const handleTokenCreatorFee = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFee = e.target.value;
    if (+newFee > 100 || +newFee < 0) {
      setError('Input valid number in a range from 0 to 100')
      setTokenCreationFee(e.target.value);
    } else {
      setError('');
      setTokenCreationFee(e.target.value);
    }
  }

  return (
      <Card
          extra={"w-full sm:h-[800px] min-h-[400px] md:h-[500px] sm:overflow-auto px-6 pb-4 mt-8"}
      >
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-10">
          <div className="flex text-base sm:w-auto sm:flex-row sm:items-center font-medium sm:text-xl">
            USD value to detect if it's cheap transaction
          </div>
          <input
              type="number"
              placeholder="USD value"
              max={100}
              min={0}
              className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-24 sm:h-full invalid:border-red-500"
              value={loading ? 'Loading fee...' : transactionUsdBound}
              onChange={handleInpuTxUsdBound}
          />
          <Button
              disabled={!transactionUsdBound.length}
              onClick={handleSetTxUsdBound}
              className="border p-2 min-w-28 rounded-md border-gray-800 hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
          >
            {setting ? 'Setting...' : 'Set USD value'}
          </Button>
        </div>
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-10">
          <div className="flex text-base sm:w-auto sm:flex-row sm:items-center font-medium sm:text-xl">
            App fee from all transactions %
          </div>
          <input
              type="number"
              placeholder="Fee"
              max={100}
              min={0}
              className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-24 sm:h-full invalid:border-red-500"
              value={loading ? 'Loading fee...' : fee}
              onChange={handleInputFee}
          />
          <Button
              disabled={!fee.length}
              onClick={handleSetFee}
              className="border p-2 min-w-28 rounded-md border-gray-800 hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
          >
            {setting ? 'Setting...' : 'Set fee'}
          </Button>
        </div>
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-10">
          <div className="flex text-base sm:w-auto sm:flex-row sm:items-center font-medium sm:text-xl">
            USD fee for cheap transactions
          </div>
          <input
              type="number"
              placeholder="USD valie"
              max={100}
              min={0}
              className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-24 sm:h-full invalid:border-red-500"
              value={loading ? 'Loading fee...' : lowFeeUsd}
              onChange={handleInputLowFeeUsd}
          />
          <Button
              disabled={!lowFeeUsd.length}
              onClick={handleSetLowFeeUsd}
              className="border p-2 min-w-28 rounded-md border-gray-800 hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
          >
            {setting ? 'Setting...' : 'Set fee'}
          </Button>
        </div>
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-10">
          <div className="flex text-base sm:w-auto sm:flex-row sm:items-center font-medium sm:text-xl">
            Shiller's reward %
          </div>
          <input
              type="number"
              placeholder="Fee"
              max={100}
              min={0}
              className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-24 sm:h-full"
              value={loading ? 'Loading fee...' : followingsFee}
              onChange={handleInputFollowingsFee}
          />
          <Button
              disabled={!followingsFee.length}
              onClick={handleSetFollowingsFee}
              className="border p-2 min-w-28 rounded-md border-gray-800 hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
          >
            {setting ? 'Setting...' : 'Set fee'}
          </Button>
        </div>
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-10">
          <div className="flex text-base sm:w-auto sm:flex-row sm:items-center font-medium sm:text-xl">
            Video creator reward %
          </div>
          <input
              type="number"
              placeholder="Fee"
              max={100}
              min={0}
              className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-24 sm:h-full"
              value={loading ? 'Loading fee...' : tokenCreationFee}
              onChange={handleTokenCreatorFee}
          />
          <Button
              disabled={!tokenCreationFee.length}
              onClick={handleSetTokenCreatorFee}
              className="border p-2 min-w-28 rounded-md border-gray-800 hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
          >
            {setting ? 'Setting...' : 'Set fee'}
          </Button>
        </div>
        <div className="flex gap-2 items-center pt-4 sm:flex-row sm:gap-5 w-full sm:pt-10">
          <div className="flex text-base sm:w-auto sm:flex-row sm:items-center font-medium sm:text-xl">
            Crowdfunding USD bound
          </div>
          <input
              type="number"
              placeholder="Fee"
              max={100}
              min={0}
              className="border rounded-md block min-h-7 bg-lightPrimary px-4 py-1 text-base font-medium text-navy-700 outline-none placeholder:!text-gray-400 sm:py-2 w-24 sm:h-full"
              value={loading ? 'Loading fee...' : crowdfundingBoundUsd}
              onChange={handleInputCrowdfundingUsdBound}
          />
          <Button
              disabled={!crowdfundingBoundUsd.length}
              onClick={handleSetCrowdfundingUsdBound}
              className="border p-2 min-w-28 rounded-md border-gray-800 hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
          >
            {setting ? 'Setting...' : 'Set fee'}
          </Button>
        </div>
        <p className="text-red-500 font-medium mt-2">{error}</p>
      </Card>
  );
};

export default FeeView;
